import { useRouter } from 'next/router'
import * as R from 'ramda'

export default function useBoardId(): string {
  const { id } = useRouter().query

  if (R.type(id) != 'String') {
    throw new Error('the current route has no board id')
  }

  if (!id) {
    throw new Error('the current route has no board id')
  }

  return String(id)
}
